import { CdaStructuredTextRecord } from 'react-datocms';
import CtaButton from 'components/CtaButton';

interface CtaBlockRecord extends CdaStructuredTextRecord {
  content: string;
  variant?: 'primary' | 'ghost' | 'link' | 'ghost-highlight';
  size?: 'xl' | 'lg' | 'sm' | 'xs';
}

export default function CtaBlock({ content, variant = 'ghost', size = 'sm' }: CtaBlockRecord) {
  const hasHighlight = variant.endsWith('-highlight');

  return (
    <CtaButton
      value={content}
      variant={(hasHighlight ? variant.slice(0, -10) : variant) as 'primary'}
      highlight={hasHighlight}
      size={size}
    />
  );
}
